import { searchEntities } from '../../store/selectors/search';
export const selectPropertyDevelopers = state => searchEntities(state, 'propertyDevelopers', ['firstname','lastname','email','phone']);